// Mobile product gallery dots. Idempotent; scoped to .product__media-list.
// Generates a dot per slide, highlights via IntersectionObserver, click scrolls.
(function () {
  if (window.__pdpDotsInit) return;
  window.__pdpDotsInit = true;

  function initList(list) {
    if (!list || list.dataset.dotsInit === '1') return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'pdp-media-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Product image pagination');

    slides.forEach(function (_, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-media-dots__dot';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
      if (i === 0) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dots.appendChild(btn);
    });

    // Insert after the slider-component wrapper (so dots sit below image)
    var host = list.closest('slider-component') || list.parentNode;
    host.parentNode.insertBefore(dots, host.nextSibling);

    var dotBtns = dots.querySelectorAll('.pdp-media-dots__dot');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (entry.intersectionRatio < 0.6) return;
        var idx = slides.indexOf(entry.target);
        if (idx < 0) return;
        dotBtns.forEach(function (b, i) {
          b.classList.toggle('is-active', i === idx);
        });
      });
    }, { root: list, threshold: [0.6, 0.9] });
    slides.forEach(function (s) { io.observe(s); });

    list.dataset.dotsInit = '1';
  }

  function initAll() {
    document.querySelectorAll('.product__media-list').forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Also re-run when variant changes may re-render gallery
  document.addEventListener('shopify:section:load', initAll);
})();
